function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { distance } from '../utils/distance';
import { DEFAULT_DRAG_START_DISTANCE } from '../utils/constants';
import { Events, triggerEvent } from '../utils/events';
import { next } from '@ember/runloop';
import { isNone } from '@ember/utils';
const DEFAULT_OPTIONS = {
  distance: DEFAULT_DRAG_START_DISTANCE
};
export default class MouseSensor {
  constructor(modifierInstance) {
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "modifierInstance", void 0);
    _defineProperty(this, "originalEvent", null);
    _defineProperty(this, "hasDragged", false);
    this.element = modifierInstance.draggableElement;
    this.modifierInstance = modifierInstance;
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMoveBeforeDragStart = this.onMouseMoveBeforeDragStart.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
  }
  attach() {
    this.element.addEventListener('mousedown', this.onMouseDown);
  }
  detach() {
    this.element.removeEventListener('mousedown', this.onMouseDown);
    document.removeEventListener('mousemove', this.onMouseMoveBeforeDragStart);
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
  }
  get options() {
    let options = this.modifierInstance.named;
    return Object.assign({}, DEFAULT_OPTIONS, options);
  }
  onMouseDown(event) {
    if (this.options.canDrag === false) {
      return;
    }

    // Only register left mouse clicks without modifiers.
    if (event.button !== 0 || event.ctrlKey || event.metaKey) {
      return;
    }

    // If there's a handle, check if mouseDown target was within or on it.
    if (this.modifierInstance.named.handle && (event.target ? isNone(event.target.closest(`.${this.modifierInstance.named.handle}`)) : true)) {
      return;
    }
    this.originalEvent = event;
    document.addEventListener('mousemove', this.onMouseMoveBeforeDragStart);
    document.addEventListener('mouseup', this.onMouseUp);
    event.stopPropagation();
  }

  // Run before actual dragging interaction. We check whether the user has
  // dragged the item across some distance (defined by the threshold), to
  // prevent dragging on regular or accidental clicks.
  onMouseMoveBeforeDragStart(event) {
    if (!this.originalEvent) {
      return;
    }
    let traveledDistance = distance(event.pageX, this.originalEvent.pageX, event.pageY, this.originalEvent.pageY);
    if (traveledDistance < (this.modifierInstance.distance ?? 0)) {
      return;
    }
    document.removeEventListener('mousemove', this.onMouseMoveBeforeDragStart);
    document.addEventListener('mousemove', this.onMouseMove);
    triggerEvent(this.element, Events.BeforeDragStart, {
      clientX: this.originalEvent.clientX,
      clientY: this.originalEvent.clientY,
      context: this.modifierInstance.context
    });
    this.hasDragged = true;

    // run in next loop so that any plugin changes done through the
    // BeforeDragStart event have had time to propagate
    next(this, () => {
      if (!this.originalEvent) {
        return;
      }
      triggerEvent(this.element, Events.DragStart, {
        clientX: this.originalEvent.clientX,
        clientY: this.originalEvent.clientY,
        context: this.modifierInstance.context
      });
    });
  }
  onMouseMove(event) {
    if (!this.originalEvent) {
      return;
    }
    triggerEvent(this.element, Events.DragMove, {
      clientX: event.clientX,
      clientY: event.clientY,
      context: this.modifierInstance.context
    });
  }
  onMouseUp(event) {
    document.removeEventListener('mousemove', this.onMouseMoveBeforeDragStart);
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.onMouseUp);
    if (this.hasDragged) {
      triggerEvent(this.element, Events.DragEnd, {
        clientX: event.clientX,
        clientY: event.clientY,
        context: this.modifierInstance.context
      });
      this.hasDragged = false;
    }
  }
}